module.exports = __webpack_public_path__ + "static/img/iExpert-icon.2de15ddf.png";